<!--Start topbar header-->
<header class="topbar-nav">
  <nav id="header-setting" class="navbar navbar-expand fixed-top bg-white">
    <ul class="navbar-nav mr-auto align-items-center">
      <li class="nav-item">
        <a class="nav-link toggle-menu" (click)="toggleSidebar()">
          <i class="icon-menu menu-icon"></i>
        </a>
      </li>
      <li class="nav-item" style="display: none;">
        <form class="search-bar">
          <input type="text" class="form-control" placeholder="Enter keywords">
          <a href="javascript:;"><i class="icon-magnifier"></i></a>
        </form>
      </li>
      <!-- Main navigation tabs -->
      <li class="nav-item" *ngIf="showMainTabs">
        <button 
          class="tab-button" 
          [ngClass]="{'active': activeTab === 'dashboard'}" 
          (click)="navigateTo('dashboard')"
          [disabled]="activeTab === 'dashboard'"
        >
          Dashboard
        </button>
      </li>
      <li class="nav-item" *ngIf="showMainTabs">
        <button 
          class="tab-button" 
          [ngClass]="{'active': activeTab === 'analytics'}" 
          (click)="navigateTo('analytics')"
          [disabled]="activeTab === 'analytics'"
        >
          Analytics
        </button>
      </li>
    </ul>
    <ul class="navbar-nav align-items-center right-nav-link">
      <!-- <li class="nav-item dropdown-lg" ngbDropdown placement="bottom-right">
             <a href="javascript:;" class="nav-link dropdown-toggle dropdown-toggle-nocaret waves-effect" id="dropdownBasic1" ngbDropdownToggle>
             <i class="fa fa-envelope-open-o"></i><span class="badge badge-danger badge-up">12</span></a>
             <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu dropdown-menu-right">
               <ul class="list-group list-group-flush">
                <li class="list-group-item d-flex justify-content-between align-items-center">
                 You have 12 new messages
                 <span class="badge badge-danger">12</span>
                 </li>
                 <li class="list-group-item">
                 <a href="javaScript:;">
                  <div class="media">
                    <div class="avatar"><img class="align-self-start mr-3" src="https://via.placeholder.com/110x110" alt="user avatar"></div>
                   <div class="media-body">
                   <h6 class="mt-0 msg-title">Jhon Deo</h6>
                   <p class="msg-info">Lorem ipsum dolor sit amet...</p>
                   <small>Today, 4:10 PM</small>
                   </div>
                 </div>
                 </a>
                 </li>
                 <li class="list-group-item">
                 <a href="javaScript:;">
                  <div class="media">
                    <div class="avatar"><img class="align-self-start mr-3" src="https://via.placeholder.com/110x110" alt="user avatar"></div>
                   <div class="media-body">
                   <h6 class="mt-0 msg-title">Sara Jen</h6>
                   <p class="msg-info">Lorem ipsum dolor sit amet...</p>
                   <small>Yesterday, 8:30 AM</small>
                   </div>
                 </div>
                 </a>
                 </li>
                 <li class="list-group-item">
                 <a href="javaScript:;">
                  <div class="media">
                    <div class="avatar"><img class="align-self-start mr-3" src="https://via.placeholder.com/110x110" alt="user avatar"></div>
                   <div class="media-body">
                   <h6 class="mt-0 msg-title">Dannish Josh</h6>
                   <p class="msg-info">Lorem ipsum dolor sit amet...</p>
                    <small>5/11/2018, 2:50 PM</small>
                   </div>
                 </div>
                 </a>
                 </li>
                 <li class="list-group-item">
                 <a href="javaScript:;">
                  <div class="media">
                    <div class="avatar"><img class="align-self-start mr-3" src="https://via.placeholder.com/110x110" alt="user avatar"></div>
                   <div class="media-body">
                   <h6 class="mt-0 msg-title">Katrina Mccoy</h6>
                   <p class="msg-info">Lorem ipsum dolor sit amet.</p>
                   <small>1/11/2018, 2:50 PM</small>
                   </div>
                 </div>
                 </a>
                 </li>
                 <li class="list-group-item text-center"><a href="javaScript:;">See All Messages</a></li>
               </ul>
               </div>
           </li>
           <li class="nav-item dropdown-lg" ngbDropdown placement="bottom-right">
             <a href="javascript:;" class="nav-link dropdown-toggle dropdown-toggle-nocaret waves-effect" id="dropdownBasic2" ngbDropdownToggle>
           <i class="fa fa-bell-o"></i><span class="badge badge-info badge-up">14</span></a>
             <div ngbDropdownMenu aria-labelledby="dropdownBasic2" class="dropdown-menu dropdown-menu-right">
               <ul class="list-group list-group-flush">
                 <li class="list-group-item d-flex justify-content-between align-items-center">
                 You have 14 Notifications
                 <span class="badge badge-info">14</span>
                 </li>
                 <li class="list-group-item">
                 <a href="javaScript:;">
                  <div class="media">
                    <i class="zmdi zmdi-accounts fa-2x mr-3 text-primary"></i>
                   <div class="media-body">
                   <h6 class="mt-0 msg-title">New Registered Users</h6>
                   <p class="msg-info">Lorem ipsum dolor sit amet...</p>
                   </div>
                 </div>
                 </a>
                 </li>
                 <li class="list-group-item">
                 <a href="javaScript:;">
                  <div class="media">
                    <i class="zmdi zmdi-coffee fa-2x mr-3 text-success"></i>
                   <div class="media-body">
                   <h6 class="mt-0 msg-title">New Received Orders</h6>
                   <p class="msg-info">Lorem ipsum dolor sit amet...</p>
                   </div>
                 </div>
                 </a>
                 </li>
                 <li class="list-group-item">
                 <a href="javaScript:;">
                  <div class="media">
                    <i class="zmdi zmdi-notifications-active fa-2x mr-3 text-secondary"></i>
                   <div class="media-body">
                   <h6 class="mt-0 msg-title">New Updates</h6>
                   <p class="msg-info">Lorem ipsum dolor sit amet...</p>
                   </div>
                 </div>
                 </a>
                 </li>
                 <li class="list-group-item text-center"><a href="javaScript:;">See All Notifications</a></li>
               </ul>
             </div>
           </li> -->

      <div aria-placeholder="bottom-right">
        <!-- <div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
          <button class="btn btn-outline-danger mr-2" id="dropdownManual" ngbDropdownAnchor (focus)="myDrop.open()"
            (change)="onCategorychange($event)">Solutions</button>
          <div ngbDropdownMenu aria-labelledby="dropdownManual">
            <button ngbDropdownItem value="2">Business</button>
            <button ngbDropdownItem value="3">Commodity</button>
            <button ngbDropdownItem value="4">Location</button>
            <button ngbDropdownItem value="4">Supplier</button>
          </div>
        </div> -->
        <div class="col">
          <div ngbDropdown class="d-inline-block">
            <!-- <button class="btn btn-outline-danger btn-round m-1" id="dropdownForm1" ngbDropdownToggle>Solutions</button> -->
            <div ngbDropdownMenu aria-labelledby="dropdownForm1" style="margin-left: -400%;">

              <div class="btn-group group-round m-1" style="width: 600px;">

                <div type="button" class="btn btn-warning col-sm-3">
                  <div class="row">
                    <img src="../../../assets/images/icon_recycle.png" height="35" class="m-1">
                    <div class="row col-md-10">
                      <span style="font-size:11px;">Trace</span>
                      <span style="font-size:6px; text-align: left;">Build Traceability across value chains</span>
                    </div>
                  </div>
                </div>

                <div type="button" class="btn btn-warning col-sm-3">
                  <div class="row">
                    <img src="../../../assets/images/icon_grain.png" height="35" class="m-1">
                    <div class="row col-md-10">
                      <span style="font-size:11px;">Procure</span>
                      <span style="font-size:6px; text-align: left;">Decisions for procuring the right quality</span>
                    </div>
                  </div>
                </div>

                <div type="button" class="btn btn-warning col-sm-3">
                  <div class="row">
                    <img src="../../../assets/images/icon_truck.png" height="25" class="m-1">
                    <div class="row col-md-10">
                      <span style="font-size:11px;">Export</span>
                      <span style="font-size:6px; text-align: left;">Lab Testing Servies for efficient exports</span>
                    </div>
                  </div>
                </div>

                <div type="button" class="btn btn-warning col-sm-3">
                  <div class="row">
                    <img src="../../../assets/images/icon_labs.png" height="35" class="m-1">
                    <div class="row col-md-10">
                      <span style="font-size:11px;">Labs</span>
                      <span style="font-size:6px; text-align: left;">SAAS Solution for managing Labs</span>
                    </div>
                  </div>
                </div>


              </div>

            </div>
          </div>
        </div>
        <!-- <select class="commodity-select dropdown-toggle p-2 text-success border-success rounded" formControlName="commodity__id">
          <option *ngFor="let com of commodityCategory" [value]="com">{{com.commodity_category_name}}</option>
        </select> -->
      </div>

      <li class="nav-item" ngbDropdown placement="bottom-right">
        <a href="javascript:;" class="nav-link dropdown-toggle dropdown-toggle-nocaret d-flex align-items-center profile-tab-trigger py-1 px-1" id="dropdownBasic3"
          ngbDropdownToggle>
          <span class="user-profile">
            <img src="../../../assets/images/aru.png" class="img-circle border" alt="user avatar">
          </span>
          <i class="fa fa-angle-down ml-1 text-muted" style="font-size: 11px;"></i>
        </a>
        <ul ngbDropdownMenu aria-labelledby="dropdownBasic3" class="dropdown-menu dropdown-menu-right shadow profile-dropdown-menu">
          <!-- User Details Header -->
          <li class="dropdown-item user-details pb-2">
            <a href="javaScript:;">
              <div class="media align-items-center">
                <div class="avatar">
                  <img class="align-self-start mr-3 img-circle" src="assets/images/aru.png" alt="user avatar" width="42" height="42">
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1 user-title font-weight-bold">{{ user?.first_name ? (user.first_name + ' ' + (user.last_name || '')) : (user?.email || 'User Profile') }}</h6>
                  <p class="user-subtitle text-muted mb-0" style="font-size: 11px;">{{ user?.email }}</p>
                </div>
              </div>
            </a>
          </li>

          <!-- Organization Switcher Dropdown Section -->
          <li *ngIf="customers && customers.length > 0" class="dropdown-divider my-1"></li>
          <li *ngIf="customers && customers.length > 0" class="profile-org-section px-3 py-2">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="org-section-title text-muted text-uppercase font-weight-bold" style="font-size: 11px; letter-spacing: 0.5px;">
                Switch Organization
              </span>
              <span class="badge badge-primary px-2" style="font-size: 10px;">{{ customers.length }}</span>
            </div>

            <!-- Organization Dropdown Selector -->
            <div class="org-dropdown-wrapper" (click)="$event.stopPropagation()">
              <div class="org-dropdown-container">
                <!-- Dropdown Trigger Button -->
                <button type="button"
                        class="org-dropdown-trigger-btn d-flex align-items-center justify-content-between w-100 p-2 rounded border"
                        [disabled]="switchingOrg"
                        (click)="toggleOrgDropdown($event)">
                  <div class="d-flex align-items-center text-truncate mr-2">
                    <div class="org-icon-box mr-2 d-flex align-items-center justify-content-center rounded">
                      <i class="fa fa-building-o"></i>
                    </div>
                    <div class="d-flex flex-column text-left text-truncate">
                      <span class="org-name-text font-weight-bold text-dark text-truncate" style="font-size: 12px; line-height: 1.2;" [title]="getCustomerName(activeCustomer)">
                        {{ getCustomerName(activeCustomer) || 'Select organization' }}
                      </span>
                      <small class="org-role-small text-muted text-uppercase mt-1" style="font-size: 9px; font-weight: 500; letter-spacing: 0.3px;">
                        {{ getCustomerRole(activeCustomer) }}
                      </small>
                    </div>
                  </div>
                  <i *ngIf="switchingOrg" class="fa fa-spinner fa-spin text-muted ml-1" style="font-size: 10px;"></i>
                  <i *ngIf="!switchingOrg" class="fa fa-chevron-down text-muted ml-1 transition-icon" [class.rotate-180]="isOrgDropdownOpen" style="font-size: 10px;"></i>
                </button>

                <!-- Dropdown Menu List (Scrollable for 20+ orgs) -->
                <div *ngIf="isOrgDropdownOpen" class="org-dropdown-menu-list mt-1 border rounded bg-white shadow-sm">
                  <!-- Search Filter for > 3 Orgs -->
                  <div *ngIf="customers.length > 3" class="p-2 border-bottom">
                    <input type="text"
                           class="form-control form-control-sm org-search-input"
                           placeholder="Search organizations..."
                           [value]="orgSearchTerm"
                           (input)="onSearchInput($event)"
                           (click)="$event.stopPropagation()">
                  </div>

                  <!-- Scrollable List of Organizations -->
                  <div class="org-list-scrollable">
                    <button type="button" *ngFor="let cust of filteredCustomers"
                         (click)="onSelectCustomer(cust, $event)"
                         class="org-dropdown-item d-flex align-items-center justify-content-between p-2 rounded"
                         [class.active-org-item]="isCustomerActive(cust)"
                         [attr.aria-pressed]="isCustomerActive(cust)"
                         [disabled]="switchingOrg"
                         [attr.aria-label]="'Switch to ' + getCustomerName(cust)">
                      <div class="d-flex align-items-center text-truncate mr-2">
                        <div class="org-icon-box mr-2 d-flex align-items-center justify-content-center rounded">
                          <i class="fa fa-building-o"></i>
                        </div>
                        <div class="d-flex flex-column text-truncate">
                          <span class="org-name-text font-weight-500 text-truncate" style="font-size: 12px; line-height: 1.2;" [title]="getCustomerName(cust)">
                            {{ getCustomerName(cust) }}
                          </span>
                          <small class="org-role-small text-muted text-uppercase mt-1" style="font-size: 9px; font-weight: 500; letter-spacing: 0.3px;">
                            {{ getCustomerRole(cust) }}
                          </small>
                        </div>
                      </div>
                      <i *ngIf="isCustomerActive(cust)" class="fa fa-check text-success ml-2 font-weight-bold" style="font-size: 11px;" aria-hidden="true"></i>
                    </button>

                    <div *ngIf="filteredCustomers.length === 0" class="text-center py-2 text-muted" style="font-size: 11px;">
                      No organization found
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="dropdown-divider my-1"></li>
          <li (click)="logout();" style="cursor: pointer;" class="dropdown-item py-2 text-danger">
            <i class="icon-power mr-2"></i> Logout
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</header>
<!--End topbar header-->